export default function initModels()
{
    const root = document.querySelector('[data-js="models"]');
    if (!root) return;

    const tablist = root.querySelector('.models__tablist');
    const tabs = [...root.querySelectorAll('.models__btn')];
    const prev = root.querySelector('.models__arrow--prev');
    const next = root.querySelector('.models__arrow--next');

    /* ---------- Tabs ---------- */
    function activate(tab, { focus = false } = {})
    {
        let activePanel = null;

        tabs.forEach((t) =>
        {
            const isActive = t === tab;
            const panel = document.getElementById(t.getAttribute('aria-controls'));

            t.classList.toggle('models__btn--active', isActive);
            t.setAttribute('aria-selected', String(isActive));
            t.tabIndex = isActive ? 0 : -1;

            if (panel) panel.hidden = !isActive;
            if (isActive) activePanel = panel;
        });

        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        root.dispatchEvent(new CustomEvent('models:change', {
            detail: { tab, panel: activePanel },
        }));
    }

    tabs.forEach((tab, i) =>
    {
        tab.addEventListener('click', () => activate(tab));

        tab.addEventListener('keydown', (e) =>
        {
            const target = {
                ArrowDown: i + 1,
                ArrowRight: i + 1,
                ArrowUp: i - 1,
                ArrowLeft: i - 1,
                Home: 0,
                End: tabs.length - 1,
            }[e.key];

            if (target === undefined) return;

            e.preventDefault();
            activate(tabs[(target + tabs.length) % tabs.length], { focus: true });
        });
    });

    /* ---------- Flechas del selector ---------- */
    const step = () => tabs[0].offsetHeight + 12;

    prev?.addEventListener('click', () => tablist.scrollBy({ top: -step() }));
    next?.addEventListener('click', () => tablist.scrollBy({ top: step() }));

    function updateArrows()
    {
        const overflows = tablist.scrollHeight > tablist.clientHeight + 1;
        if (prev) prev.hidden = !overflows;
        if (next) next.hidden = !overflows;
    }

    updateArrows();
    window.addEventListener('resize', updateArrows);
}
